import { Button } from '@design-system';
import { useTranslation } from 'next-i18next';

import { Modal } from '../../../Dialog/Modal';
import { Image } from '../../../Image';

const SECTION_IMAGES = {
  section1: 'https://images.avantarte.org/media/3BiS60il49OhaVIP9rlSEE099H0',
  section2: 'https://images.avantarte.org/media/3BiS67sTOjeMgnGWfQ8ahkmnelg',
} as const;

const SECTION_KEYS = ['section1', 'section2'] as const;

export interface MountingGuideDialogProps {
  open: boolean;
  onClose: () => void;
}

export const MountingGuideDialog = ({
  onClose,
  open,
}: MountingGuideDialogProps) => {
  const { t } = useTranslation('checkout');
  const title = t('framing.mountingGuide.title');

  return (
    <Modal
      dismissible
      onClose={onClose}
      open={open}
      overlayOtherDialogs
      title={title}
      verticalAlign="center"
    >
      <div className="relative flex max-h-[80dvh] w-full flex-col overflow-y-scroll rounded-t-lg bg-white no-scrollbar md:max-w-md md:overflow-y-auto md:rounded-lg">
        <div className="sticky top-0 z-30 flex w-full items-center justify-center bg-white p-6">
          <p className="text-center text-md font-bold">{title}</p>
          <div className="absolute right-5 top-5 flex h-9 w-9 items-center justify-center">
            <Button
              hideLabel
              icon="ic_close"
              label="Close"
              onClick={onClose}
              size="sm"
              type="button"
              variant="transparent"
            />
          </div>
        </div>

        <div className="flex flex-col gap-6 p-6 pt-0">
          {SECTION_KEYS.map((sectionKey) => {
            const sectionTitle = t(`framing.mountingGuide.${sectionKey}.title`);

            return (
              <div key={sectionKey} className="flex flex-col gap-3">
                <p className="text-pretty font-bold">{sectionTitle}</p>
                <p className="text-pretty">
                  {t(`framing.mountingGuide.${sectionKey}.description`)}
                </p>
                <Image
                  alt={`Image for: ${sectionTitle}`}
                  size={{
                    sm: { ratio: '4/3', span: 12 },
                    md: { ratio: '4/3', span: 4 },
                    lg: { ratio: '4/3', span: 4 },
                  }}
                  src={SECTION_IMAGES[sectionKey]}
                />
              </div>
            );
          })}
        </div>
      </div>
    </Modal>
  );
};
